<template>
  <div class="d-flex align-center px-1">
    <slot name="top" :rows="itensFiltrados">
      <template v-if="title && title.trim().length > 0">
        <v-icon left style="font-size: 20px">mdi-format-list-bulleted</v-icon>
        <span class="subtitle-1 font-weight-medium">{{title}}</span>
      </template>

      <v-spacer />

      <slot name="top-right"></slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: {
      type: String,
      default: ''
    },
    itensFiltrados: Array,
  }
}
</script>

<style scoped>

</style>
